import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { registerAuthEventListeners } from "./middleware/eventListenerMiddleware";

const store = configureStore({
  reducer: rootReducer,
});

registerAuthEventListeners(store);

export default store;
